import { render, staticRenderFns } from "./InfosDgv.vue?vue&type=template&id=06b143c5&scoped=true"
import script from "./InfosDgv.vue?vue&type=script&lang=js"
export * from "./InfosDgv.vue?vue&type=script&lang=js"
import style0 from "./InfosDgv.vue?vue&type=style&index=0&id=06b143c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b143c5",
  null
  
)

export default component.exports